/*
  Collection of custom validation rules for trades form
*/
import {required, numeric, requiredIfFieldContains} from '../../helpr/generic-validation-rules';
import {optionsMember} from "./registration-form-validation-rules";

export const investorDetailsObj = obj => {
  return {
    fields: {
      securityId: {
        value: obj.securityId,
        style: {}
      },
      faceAmount: {
        value: obj.faceAmount,
        style: {}
      },
      settlementDate: {
        value: obj.settlementDate,
        style: {}
      },
      investorCategoryType: {
        value: obj.investorCategory.type,
        style: {}
      },
      investorCategoryUnder: {
        value: obj.investorCategory.under,
        style: {}
      },
      investorIndividualSalutation: {
        value: obj.investorIndividual.salutation,
        style: {}
      },
      investorIndividualLastName: {
        value: obj.investorIndividual.lastName,
        style: {}
      },
      investorIndividualFirstName: {
        value: obj.investorIndividual.firstName,
        style: {}
      },
      investorIndividualMiddleName: {
        value: obj.investorIndividual.middleName,
        style: {}
      },
      investor: {
        value: obj.investor,
        style: {}
      },
      dateBirthIncorporation: {
        value: obj.dateBirthIncorporation,
        style: {}
      },
      placeBirthIncorporation: {
        value: obj.placeBirthIncorporation,
        style: {}
      },
      domicile: {
        value: obj.domicile,
        style: {}
      },
      nationality: {
        value: obj.nationality,
        style: {}
      },
      usResident: {
        value: obj.usResident,
        style: {}
      },
      usResidentCard: {
        value: obj.usResidentCard,
        style: {}
      },
      usCitizen: {
        value: obj.usCitizen,
        style: {}
      },
      organizationType: {
        value: obj.organizationType,
        style: {}
      },
      parentCompany: {
        value: obj.parentCompany,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

/*
  Trade Transfer Form (Transfer Instruction) Fields Configuration
  Validation rules setup for use-validation hook
*/
export const investorDetailsValidator = {
  /* Set Default Values plus their respective validation rules*/
  fields: {
    securityId: [required],
    faceAmount: [required, numeric],
    settlementDate: [required],
    investorCategoryType: [
      required,
      v => optionsMember(v, 'investorCategory')
    ],
    investorCategoryUnder: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['CORP'])
    ],
    investorIndividualSalutation: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['INDV'])
    ],
    investorIndividualLastName: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['INDV'])
    ],
    investorIndividualFirstName: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['INDV'])
    ],
    investorIndividualMiddleName: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['INDV'])
    ],
    investor: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['CORP'])
    ],
    dateBirthIncorporation: [required],
    placeBirthIncorporation: [required],
    domicile: [required],
    nationality: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['INDV'])
    ],
    usResident: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['INDV'])
    ],
    usResidentCard: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['INDV'])
    ],
    usCitizen: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['INDV'])
    ],
    organizationType: [
      v => requiredIfFieldContains(v, 'investorCategoryType', ['CORP'])
    ],
    parentCompany: []
  },
  dynamicFields: {}
}

